import type { ContentItem } from "../../types";

export interface RendererProps {
  item: ContentItem;
  moduleID: string;
  onComplete: () => void;
}

// contentOf narrows an item's untyped JSON payload to the shape the
// renderer for that content type expects. The admin portal validates the
// payload on save, so renderers treat every field as optional and fall
// back rather than throwing on partially filled content.
export function contentOf<T>(item: ContentItem): Partial<T> {
  return (item.content || {}) as Partial<T>;
}

export interface MediaFile {
  id?: string;
  file_name?: string;
  file_url?: string;
  description?: string;
}

export interface ImageAsset {
  id?: string;
  url?: string;
  alt_text?: string;
  caption?: string;
}

export interface VideoContent {
  source?: "uploaded" | "youtube" | "vimeo";
  video_url?: string;
  poster_url?: string;
  subtitle_url?: string;
  caption?: string;
}

export interface AudioContent {
  audio_url?: string;
  cover_image_url?: string;
  caption?: string;
}

export interface AudioSlidesContent extends AudioContent {
  slides?: { image_url?: string; title?: string; timestamp_seconds?: number }[];
}

export interface TextContent {
  body?: string;
}

export interface ImageContent {
  images?: ImageAsset[];
}

export interface SlidesContent {
  title?: string;
  description?: string;
  file_type?: string;
  file_url?: string;
}

export interface DownloadContent {
  description?: string;
  file_url?: string;
  file_name?: string;
}

export interface ResourcePackContent {
  description?: string;
  files?: MediaFile[];
}

export interface LinkContent {
  url?: string;
  label?: string;
  description?: string;
  thumbnail_url?: string;
  open_in?: "current" | "new";
}

export interface EmbedContent {
  provider?: string;
  embed_url?: string;
  title?: string;
  aspect_ratio?: string;
}

export interface PracticalActivityContent {
  instructions?: string;
  files?: MediaFile[];
  response_type?: "short_text" | "long_text" | string;
}

export interface ReflectionContent {
  prompt?: string;
  response_type?: "short_text" | "long_text" | string;
  min_length?: number;
  max_length?: number;
}
